import { Container, Row, Col, Offcanvas } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import React from "react";
import { loadAuth } from "../../../libs/authMgmt";
import PlanManager from "../../plansMgr";
import { Menu } from "lucide-react";
import { accountNav, homeNav, productMgntNav, systemNav } from "../../nav";
import * as LucideIcons from "lucide-react";
import { Link } from "react-router-dom";

export default function SubHeader() {
  const elementRef = useRef(null);
  const [height, setHeight] = useState(0);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  const [isMenuHidden, setIsMenuHidden] = useState(() => {
    // Initialize state from localStorage
    const savedToggleNav = localStorage.getItem("toggleNav");
    return savedToggleNav === "true";
  });
  const companyName = loadAuth("company")?.name ?? "Dab's Taco Shop";
  const user = loadAuth("user");
  const role = loadAuth("role");

  const handleMenuClick = () => {
    const newToggleState = !isMenuHidden;

    // Save to localStorage
    localStorage.setItem("toggleNav", newToggleState.toString());

    const nestNav = document.querySelector(".nest_nav");
    const mainCont = document.querySelector(".main_dashboard");
    // find all elements with class nav-text
    const navTextElements = document.querySelectorAll(".nav-text");
    const navHeaders = document.querySelectorAll(".nav-link-headers");

    if (nestNav && mainCont) {
      if (newToggleState) {
        // Hide menu
        setTimeout(() => {
          navTextElements.forEach((navLi) => {
            navLi.classList.add("nav_li_hide");
          });
          navHeaders.forEach((navHeader) => {
            navHeader.classList.add("nav_li_hide");
          });
          setTimeout(() => {
            nestNav.classList.add("nest_nav_menu_hide");
            mainCont.classList.add("main_dashboard_full");
          }, 100);
        }, 50);
        setIsMenuHidden(true);
      } else {
        // Show menu
        setTimeout(() => {
          nestNav.classList.remove("nest_nav_menu_hide");
          mainCont.classList.remove("main_dashboard_full");
          setTimeout(() => {
            navTextElements.forEach((navLi) => {
              navLi.classList.remove("nav_li_hide");
            });
            navHeaders.forEach((navHeader) => {
              navHeader.classList.remove("nav_li_hide");
            });
          }, 100);
        }, 50);
        setIsMenuHidden(false);
      }
    }
  };

  // Apply saved navigation state on component mount
  useEffect(() => {
    const savedToggleNav = localStorage.getItem("toggleNav");
    const shouldHideNav = savedToggleNav === "true";

    if (shouldHideNav) {
      const nestNav = document.querySelector(".nest_nav");
      const mainCont = document.querySelector(".main_dashboard");
      const navTextElements = document.querySelectorAll(".nav-text");
      const navHeaders = document.querySelectorAll(".nav-link-headers");

      if (nestNav && mainCont) {
        // Apply hidden state immediately on load
        navTextElements.forEach((navLi) => {
          navLi.classList.add("nav_li_hide");
        });
        navHeaders.forEach((navHeader) => {
          navHeader.classList.add("nav_li_hide");
        });
        nestNav.classList.add("nest_nav_menu_hide");
        mainCont.classList.add("main_dashboard_full");
      }
    }
  }, []);

  useEffect(() => {
    if (elementRef.current) {
      setHeight(elementRef.current.clientHeight);
      console.log(elementRef.current.clientHeight);
    }
  }, []);
  return (
    <>
      <div className="sub_top_nav" ref={elementRef}>
        <Container fluid>
          <Row>
            <Col
              xl={6}
              lg={8}
              sm={12}
              md={12}
              xs={12}
              className="position-relative "
            >
              <div
                className="sub_top_nav_mobile"
                style={{
                  // align content middle
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div className="company_name xl_menu">
                  <Menu
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleMenuClick();
                    }}
                  />{" "}
                  <span> &nbsp; &nbsp; Hello {user?.name ?? "User"}!</span>
                </div>
                <div className="mobile_menu">
                  <Container fluid>
                    <Row>
                      <Col sm={4} xs={4}>
                        <div
                          onClick={() => {
                            handleShow();
                          }}
                          style={{
                            // align content middle
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <Menu
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleMenuClick();
                            }}
                          />
                        </div>
                      </Col>
                      <Col
                        sm={4}
                        xs={4}
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            // align content middle
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <img src="/landing/nest_text.png" alt="Nest Text" />
                        </div>
                      </Col>

                      <Col sm={4} xs={4} style={{ textAlign: "right" }}>
                        <div
                          style={{
                            // align content middle
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "right",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <div
                            className="company_user_img_mobile"
                            style={{
                              backgroundImage: `url("${
                                loadAuth("user")?.imageUrl ||
                                "https://static.vecteezy.com/system/resources/previews/043/900/708/non_2x/user-profile-icon-illustration-vector.jpg"
                              }")`,
                            }}
                          ></div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <div
                  className="company_logo invisible"
                  style={{
                    width: 0,
                    backgroundImage: `url("/company_logo.png")`,
                  }}
                ></div>
                <>
                  {loadAuth("role") === "admin" ? (
                    <>
                      <PlanManager />
                    </>
                  ) : (
                    ""
                  )}
                </>
              </div>
            </Col>
            <Col
              xl={6}
              lg={4}
              md={6}
              className="xl_menu"
              style={{
                position: "relative",
                // align content middle
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <div className="company_nav">
                <div
                  className="company_user_img"
                  style={{
                    backgroundImage: `url("${
                      loadAuth("user")?.imageUrl ||
                      "https://static.vecteezy.com/system/resources/previews/043/900/708/non_2x/user-profile-icon-illustration-vector.jpg"
                    }")`,
                  }}
                ></div>
                <div className="company_username">
                  <div className="name-text">
                    {user?.name ?? "Christian Dab Juan"}
                  </div>
                  <div className="name-position text-capitalize">
                    {role ?? "Prince"}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <Offcanvas
          show={show}
          onHide={handleClose}
          className="mobile_offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {/* company name */}
              {companyName}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="mobile_offcanvas_content">
              <div className={"nav-link-headers"}>Home</div>
              <ul>
                {homeNav?.map((data, i) => {
                  const Icon = LucideIcons[data.icon];
                  return (
                    <li
                      key={i}
                      className={`${
                        window.location.pathname === data.link ||
                        (data.link === "/dashboard"
                          ? window.location.pathname === "/"
                          : false)
                          ? "active-link"
                          : ""
                      }`}
                    >
                      <Link to={data.link} onClick={scrollToTop}>
                        <span>
                          {Icon &&
                            React.createElement(Icon, {
                              size: 42,
                              className: "icon-nav",
                            })}
                        </span>
                        <span className="nav-text">{data.label}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>

              <div className={"nav-link-headers"}>Product Management</div>
              <ul>
                {productMgntNav?.map((data, i) => {
                  const Icon = LucideIcons[data.icon];
                  return (
                    <li
                      key={i}
                      className={`${
                        window.location.pathname === data.link
                          ? "active-link"
                          : window.location.pathname === data.link
                          ? "active-link"
                          : ""
                      }`}
                    >
                      <Link to={data.link} onClick={scrollToTop}>
                        <span>
                          {Icon &&
                            React.createElement(Icon, {
                              size: 42,
                              className: "icon-nav",
                            })}
                        </span>
                        <span className="nav-text">{data.label}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              {loadAuth("role") === "admin" ? (
                <>
                  <div className={"nav-link-headers"}>Account Management</div>
                  <ul>
                    {accountNav?.map((data, i) => {
                      const Icon = LucideIcons[data.icon];
                      return (
                        <li
                          key={i}
                          className={`${
                            window.location.pathname === data.link
                              ? "active-link"
                              : " "
                          }`}
                        >
                          <Link to={data.link} onClick={scrollToTop}>
                            <span>
                              {Icon &&
                                React.createElement(Icon, {
                                  size: 42,
                                  className: "icon-nav",
                                })}
                            </span>
                            <span className="nav-text">{data.label}</span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </>
              ) : (
                ""
              )}
              <div className={"nav-link-headers"}>System</div>
              <ul>
                {systemNav?.map((data, i) => {
                  const Icon = LucideIcons[data.icon];
                  return (
                    <li
                      key={i}
                      className={`${
                        window.location.pathname === data.link
                          ? "active-link"
                          : ""
                      }`}
                    >
                      <Link to={data.link} onClick={scrollToTop}>
                        <span>
                          {Icon &&
                            React.createElement(Icon, {
                              size: 42,
                              className: "icon-nav",
                            })}
                        </span>
                        <span className="nav-text">{data.label}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      <div
        style={{
          height: `${height}px`,
        }}
      ></div>
    </>
  );
}
